(function() {
    angular
        .module('ngmvac')
        .directive('facilities', Facilities);
Facilities.$inject = ['fontNames', 'ContentApiService'];
    function Facilities(fontNames, ContentApiService) {
        var ListFacilidades = {};
        var ShowList = false;
        var ShowListFac = false;
                
                
        return {
			restrict: 'EA',
			template: [
				'<span ng-bind-html="MostrarFacilidades"></span>'
			].join(''),
			scope: {
				code: '='
			},
			link: function(scope, element, attrs) {
                ContentApiService.get([scope.code]).then(function(response) {
                // angular.forEach(response.data.hotels[0].facilitiesDescription, function(ContentDescription) {
                //     angular.forEach(ContentDescription.content, function(Content) {
                //         MostrarFacilidades = MostrarFacilidades + 
                //         '<i data-toggle="tooltip" title="'+Content.description+'" class="'+fontNames[Content.facility_code+'-'+ContentDescription.code]+'" ></i>'; 
                //         scope.MostrarFacilidades = MostrarFacilidades;
                //     });    
                // });
                var MostrarFacilidades = '';
                var ListFacilidades = {};
                var cont = 0;
                
                ListFacilidades = {
                    facilitiesDescription : response.data.hotels[0].facilitiesDescription
                };

                if(ListFacilidades.facilitiesDescription.length <=3){
                    for(var x = 0; x< ListFacilidades.facilitiesDescription.length; x++){
                        for(var y=0; y < ListFacilidades.facilitiesDescription[x].content.length; y++){
                            if(ListFacilidades.facilitiesDescription[x].code != 60){
                                cont++;
                                if(cont > 4){
                                    break;
                                }

                                if(fontNames[ListFacilidades.facilitiesDescription[x].content[y].facility_code+'-'+ListFacilidades.facilitiesDescription[x].code] == ''){
                                    MostrarFacilidades = MostrarFacilidades + 
                                    '<i data-toggle="tooltip" title="'+ListFacilidades.facilitiesDescription[x].content[y].description+'" class="icon-check" ></i>';    
                                }else{
                                    MostrarFacilidades = MostrarFacilidades + 
                                    '<i data-toggle="tooltip" title="'+ListFacilidades.facilitiesDescription[x].content[y].description+'" class="'+fontNames[ListFacilidades.facilitiesDescription[x].content[y].facility_code+'-'+ListFacilidades.facilitiesDescription[x].code]+'" ></i>';    
                                }
                                scope.MostrarFacilidades = MostrarFacilidades;
                                ShowListFac = true;
                                scope.ShowListFac = ShowListFac;
                            }
                        }
                    }
                }else{
                    for(var x = 0; x< ListFacilidades.facilitiesDescription.length; x++){
                        for(var y=0; y < ListFacilidades.facilitiesDescription[x].content.length; y++){
                            if(y==1){
                                break;
                            }
                                    
                            if(ListFacilidades.facilitiesDescription[x].code != 60){
                                cont++;
                                        
                                if(cont > 4){
                                    break;
                                }
                                        
                                if(fontNames[ListFacilidades.facilitiesDescription[x].content[y].facility_code+'-'+ListFacilidades.facilitiesDescription[x].code] == ''){
                                    MostrarFacilidades = MostrarFacilidades + 
                                        '<i data-toggle="tooltip" title="'+ListFacilidades.facilitiesDescription[x].content[y].description+'" class="icon-check" ></i>';    
                                }else{
                                    MostrarFacilidades = MostrarFacilidades + 
                                    '<i data-toggle="tooltip" title="'+ListFacilidades.facilitiesDescription[x].content[y].description+'" class="'+fontNames[ListFacilidades.facilitiesDescription[x].content[y].facility_code+'-'+ListFacilidades.facilitiesDescription[x].code]+'" ></i>';    
                                }
                                scope.MostrarFacilidades = MostrarFacilidades;
                                ShowListFac = true;
                                scope.ShowListFac = ShowListFac;
                                
                            }   
                        }
                    }
                }
            })
            .catch(function(err) {
                // console.log(code, 'Error');
                // console.clear();
                ShowListFac = true;
                scope.ShowListFac = ShowListFac;
                ShowList = true;
                scope.ShowList = ShowList
                MostrarFacilidades = '<i tooltip title="wifi" class="icon-wifi toltip"></i>'+
                                '<i tooltip title="palm-tree" class="icon-palm-tree"></i>'+
                                '<i tooltip title="shop" class="icon-shop"></i>'+
                                '<i tooltip title="barbell" class="icon-barbell"></i>';
                scope.MostrarFacilidades = MostrarFacilidades;
            });
            }
        }
    }
})();
